<template>
  <div id="automation-creation-content">
    <Select
      class="scs-input"
      heading="From"
      :options="emails"
      @input="emailInput"
    />
    <Input
      class="scs-input"
      heading="Subject"
      :error="errors.subject"
      :initialValue="automation ? automation.action.email.subject : undefined"
      @scs-input="subjectInput"
    />
    <TextArea
      class="scs-input"
      heading="Content (HTML enabled)"
      :error="errors.content"
      :initialValue="automation ? automation.action.email.content : undefined"
      @scs-input="contentInput"
    />
  </div>
</template>
<script>
import Input from "../../../../../../Components/Elements/Input.vue";
import Select from "../../../../../../Components/Elements/Select.vue";
import TextArea from "../../../../../../Components/Elements/TextArea.vue";
export default {
  data() {
    return {};
  },
  computed: {
    emails() {
      return this.$store.getters.businessEmailAddresses;
    },
  },
  methods: {
    emailInput(value) {
      this.$emit("email-input", value);
    },
    subjectInput(value) {
      this.$emit("subject-input", value);
    },
    contentInput(value) {
      this.$emit("content-input", value);
    },
  },
  created() {},
  components: {
    Input,
    TextArea,
    Select,
  },
  emits: ["email-input", "subject-input", "content-input"],
  props: ["automation", "errors"],
};
</script>
<style scoped>
@media screen {
  #automation-creation-content {
    height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
  }

  .scs-input {
    width: 100%;
    margin: 10px;
  }
  @media (min-width: 800px) {
    .scs-input {
      width: 350px;
    }
  }
}
</style>
